import { useState } from 'react';
import { Button, message } from 'antd';

import bgImage from './chartBg.png';
import ModalSurvey, { FormValues } from '../ModalSurvey';
import { Question } from '../../../../../store/subCategory';
import {
  AnswerCreateData,
  QuestionCreateResponse,
  useQuestionAnswerCreate,
} from '../../../../../hooks/api/answers';
import SurveySuccess from '../ModalSurvey/SurveySuccess';
import {
  DefaultFetchError,
  getMessageInError,
} from '../../../../../hooks/fetch';
import useAuthModals from '../../../../Layout/Menu/useAuthModals';
import { useAuth } from '../../../../../store/auth';

import styles from './index.module.scss';

interface TakeSurveyProps {
  questions: Question[];
  onSuccess: () => void;
  autoOpen?: boolean;
  onExit?: () => void;
}

function TakeSurvey({
  questions,
  onSuccess,
  autoOpen,
  onExit,
}: TakeSurveyProps) {
  const { user, authorized } = useAuth();
  const { content, openLoginModal } = useAuthModals();
  const [isOpen, setIsOpen] = useState(autoOpen ?? false);
  const [response, setResponse] = useState<(QuestionCreateResponse | null)[] | null>(null);

  const answerCreate = useQuestionAnswerCreate();

  const onFinish = (values: FormValues) => {
    const ansvers: AnswerCreateData[] = Object.entries(values)
      .filter(([key]) => questions.some((q) => q.id === key))
      .map(([questionId, value]): AnswerCreateData => {
        const answer: AnswerCreateData = {
          questionId,
          tipType: '%',
        };

        if (typeof value.value === 'boolean') answer.valueBoolean = value.value;
        if (typeof value.value === 'string') answer.valueString = value.value;
        if (typeof value.value === 'number') answer.valueNumber = value.value;
        if (Array.isArray(value.value)) answer.valueArray = value.value;
        if (value.tipType) answer.tipType = value.tipType;

        return answer;
      });

    Promise.all(ansvers.map((ansver) => answerCreate.fetch(ansver)))
      .then((resp) => {
        message.success('Successfuly saved!');
        onSuccess();
        setResponse(resp);
      })
      .catch((error: DefaultFetchError) => {
        message.error(getMessageInError(error));
      });
  };

  const handleClick = () => {
    if (!authorized) {
      openLoginModal();

      return;
    }
    if (user?.country?.id !== 233) {
      console.log('user not allowed to take survey since he not from US');

      return;
    }
    setIsOpen(true);
  };

  return (
    <div className={styles.wrapper}>
      {/* eslint-disable-next-line no-nested-ternary */}
      {!isOpen ? (
        <>
          <div className={styles.bgImageWrapper}>
            <img src={bgImage} alt="Take Survey Background" />
          </div>
          <div className={styles.blur} />
          <div className={styles.content}>
            <h3 className={styles.title}>
              Curious how different factors affect tipping behavior?
            </h3>
            <div className={styles.description}>
              Take our short survey to unlock results
            </div>
            <div className={styles.buttonWrapper}>
              <Button
                type="primary"
                className={styles.button}
                onClick={handleClick}
              >
                Take Survey
              </Button>

              {content}
            </div>
          </div>
        </>
      ) : (response ? (
        <div className={styles.successWrapper}>
          <div className={styles.container}>
            <SurveySuccess viewResults={() => setIsOpen(false)} />
          </div>
        </div>
      ) : (
        <ModalSurvey
          isOpen={isOpen}
          questions={questions}
          onFinish={onFinish}
          onExit={onExit}
        />
      ))}
    </div>
  );
}

export default TakeSurvey;
